import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { useSeo } from "@/lib/seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  useSeo("Área Administrativa | HB Solar", "Acesso restrito à administração do site HB Solar.");
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email: email.trim(), password });
      localStorage.setItem("hb_admin_token", data.token);
      toast.success("Login realizado!");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Não foi possível entrar. Tente novamente.");
    }
    setLoading(false);
  };

  return (
    <section className="relative grain min-h-screen bg-[#0B192C] pt-[76px] flex items-center justify-center px-5 py-16">
      <div className="w-full max-w-md">
        <form
          data-testid="admin-login-form"
          onSubmit={handleSubmit}
          className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur p-8 sm:p-10"
        >
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-400 text-[#0B192C]">
            <Lock className="h-6 w-6" />
          </span>
          <h1 className="mt-6 text-center font-display text-2xl font-bold text-white">
            Área Administrativa
          </h1>
          <p className="mt-2 text-center text-sm text-slate-400">
            Acesso restrito — HB Solar / HB Charger
          </p>

          <label htmlFor="admin-email" className="mt-8 block text-xs font-bold uppercase tracking-[0.16em] text-slate-400 mb-2">
            E-mail
          </label>
          <input
            id="admin-email"
            data-testid="admin-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3.5 text-white placeholder:text-slate-500 outline-none focus:border-amber-400 focus:ring-4 focus:ring-amber-400/20 transition-all"
            placeholder="seu e-mail"
            required
          />
          <label htmlFor="admin-password" className="mt-5 block text-xs font-bold uppercase tracking-[0.16em] text-slate-400 mb-2">
            Senha
          </label>
          <input
            id="admin-password"
            data-testid="admin-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3.5 text-white placeholder:text-slate-500 outline-none focus:border-amber-400 focus:ring-4 focus:ring-amber-400/20 transition-all"
            placeholder="sua senha"
            required
          />

          {error && (
            <p data-testid="admin-login-error" className="mt-4 rounded-xl bg-red-500/15 border border-red-400/30 px-4 py-3 text-sm font-semibold text-red-300">
              {error}
            </p>
          )}

          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="mt-7 w-full inline-flex items-center justify-center gap-2 rounded-full bg-amber-400 hover:bg-amber-300 text-[#0B192C] font-extrabold px-6 py-4 transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : null}
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
        <Link to="/" className="mt-6 flex items-center justify-center gap-2 text-sm font-semibold text-slate-400 hover:text-amber-400 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Voltar ao site
        </Link>
      </div>
    </section>
  );
}
